/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 *
 **/

import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  accountSidLabel: {
    id: 'twilio-auth.accountSidLabel',
    defaultMessage: 'Account SID'
  },
  accountSidPlaceholder: {
    id: 'twilio-auth.accountSidPlaceholder',
    defaultMessage: 'Enter Twilio account SID'
  },
  accountSidRequired: {
    id: 'twilio-auth.accountSidRequired',
    defaultMessage: 'Account SID is required.'
  },
  accountSidError: {
    id: 'twilio-auth.accountSidError',
    defaultMessage:
      'Must be 34 characters long and starting only number characters (0-9) and specific alphabetical characters (A-C and a-f).'
  },
  authTokenLabel: {
    id: 'twilio-auth.authTokenLabel',
    defaultMessage: 'Auth token'
  },
  authTokenPlaceholder: {
    id: 'twilio-auth.authTokenPlaceholder',
    defaultMessage: 'Enter Twilio auth token'
  },
  authTokenRequired: {
    id: 'twilio-auth.authTokenRequired',
    defaultMessage: 'Auth token is required.'
  },
  authTokenError: {
    id: 'twilio-auth.authTokenError',
    defaultMessage:
      'Must be 32 characters long and contain only number characters (0-9) and specific alphabetical characters (a-f).'
  },
  syncButtonLabel: {
    id: 'twilio-auth.syncButtonLabel',
    defaultMessage: 'Sync account'
  },
  syncMessageFailure: {
    id: 'twilio-auth.syncMessageFailure',
    defaultMessage: 'Failed to sync account'
  },
  syncMessage: {
    id: 'twilio-auth.syncMessage',
    defaultMessage: 'Syncing account...'
  },
  syncMessageSuccess: {
    id: 'twilio-auth.syncMessageSuccess',
    defaultMessage: 'Synced'
  },
  webhookUri: {
    id: 'twilio-auth.webhookUri',
    defaultMessage: 'Webhook URI (uniform resource identifier)'
  }
});

export const AccountSidStepMessages = defineMessages({
  title: {
    id: 'twilio-auth.AccountSidStepMessages.title',
    defaultMessage: 'Account SID'
  },
  description: {
    id: 'twilio-auth.AccountSidStepMessages.description',
    defaultMessage:
      "In your Twilio project's dashboard, refer to your project info and copy and paste the account SID value below."
  }
});

export const AuthTokenStepMessages = defineMessages({
  title: {
    id: 'twilio-auth.AuthTokenStepMessages.title',
    defaultMessage: 'Auth token'
  },
  description: {
    id: 'twilio-auth.AuthTokenStepMessages.description',
    defaultMessage:
      "In your Twilio project's dashboard, refer to your project info and copy and paste the auth token value below."
  }
});

export const WebhookStepMessages = defineMessages({
  title: {
    id: 'twilio-auth.WebhookStepMessages.title',
    defaultMessage: 'Webhook'
  },
  webhookErrorTitleTwilio: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorTitleTwilio',
    defaultMessage: "We're unable to connect to your Twilio account."
  },
  webhookErrorSubtitleTwilio: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorSubtitleTwilio',
    defaultMessage:
      'Please check your account SID and auth token and then try again.'
  },
  webhookErrorTitleIntelepeer: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorTitleIntelepeer',
    defaultMessage: "We're unable to connect to your IntelePeer account."
  },
  webhookErrorSubtitleIntelepeer: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorSubtitleIntelepeer',
    defaultMessage:
      'Please check your account secret and auth token and then try again.'
  },
  webhookErrorTitleGenesys: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorTitleGenesys',
    defaultMessage: "We're unable to connect to your Genesys account."
  },
  webhookErrorSubtitleGenesys: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorSubtitleGenesys',
    defaultMessage:
      'Please check your customer Id, Customer secret, Verification Token and API URI and then try again.'
  },
  webhookErrorTitleByop: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorTitleCustomSMS',
    defaultMessage:
      "We're unable to connect to your Custom SMS provider account."
  },
  webhookErrorSubtitleByop: {
    id: 'twilio-auth.WebhookStepMessages.webhookErrorSubtitleGenesys',
    defaultMessage: `Please check your custom SMS provider's Verification Token and then try again.`
  }
});

export const TwilioMessagingWebhookStepMessages = defineMessages({
  description: {
    id: 'twilio-auth.TwilioMessagingWebhookStepMessages.description',
    defaultMessage:
      "Copy and paste this webhook identifier as the address for incoming messages. Make sure it's set to HTTP POST."
  },
  webhookLabel: {
    id: 'twilio-auth.TwilioMessagingWebhookStepMessages.webhookLabel',
    defaultMessage: 'Webhook URI'
  }
});

export const WhatsAppWebhookStepMessages = defineMessages({
  description: {
    id: 'twilio-auth.WhatsAppWebhookStepMessages.description',
    defaultMessage:
      'Copy the uniquely generated webhook below and provide to Twilio. This will allow messages to be sent and received.'
  },
  webhookLabel: {
    id: 'twilio-auth.WhatsAppWebhookStepMessages.webhookLabel',
    defaultMessage: 'Webhook'
  }
});
